import {
	AccidentImg,
	CancerImg,
	ChristmasClubImg,
	ClinicCardImg,
	CriticalIllnessImg,
	DocAndRXImg,
	GLIImg,
	GLTDClass1Img,
	GLTDClass2Img,
	GSTDImg,
	HOOImg,
	HealthPlanImg,
	HospitalIndemnityImg,
	KSOPImg,
	LimitedIndemnityImg,
	STDImg,
	TermLifeImg,
	Vision2Image,
	WholeLifeImg,
	DentalMaxCareImage,
	TermLifeCoverageImg
} from "../assets";

export const CorePlanImage = {
	health_plan: HealthPlanImg,
	clinic_card: ClinicCardImg,
	gstd: GSTDImg,
	gltd_class_1: GLTDClass1Img,
	gltd_class_2: GLTDClass2Img,
	ksop: KSOPImg,
	helping_our_own: HOOImg,
	christmas_club_election: ChristmasClubImg,
	group_life_insurance: GLIImg
};

export const VebPlanImage = {
	cancer: CancerImg,
	whole_life: WholeLifeImg,
	short_term_disability: STDImg,
	critical_illness: CriticalIllnessImg,
	term_life_coverage: TermLifeCoverageImg,
	hospital_indemnity: HospitalIndemnityImg,
	accident: AccidentImg,
	limited_indemnity_insurance: LimitedIndemnityImg,
	term_life_to_age_121: TermLifeImg,
	doc_and_rx: DocAndRXImg,
	vision: Vision2Image,
	dental: DentalMaxCareImage
};
